import React from "react";
import SocialLinks from "../social/Links";
import "./style.css";

let onClick = (e) => {
  e.preventDefault();
  console.log("onclick..");
};
function index() {
  return (
    <div className="bg-light-gray padding-100px-top banner">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-12 order-2 order-md-1 xs-padding-50px-tb">
            <div className="padding-twenty-top sm-padding-fifteen-top xs-no-padding">
              <h5 className="bannerText no-margin font-size18 xs-font-size16 text-medium-gray padding-twelve-top sm-padding-five-top xs-no-padding">
                Hello, I am
              </h5>
              <h1 className="bannerText text-uppercase font-size48 md-font-size42 sm-font-size36 xs-font-size26 font-weight-700 margin-20px-bottom">
                Irfan G G
              </h1>
              <p className="bannerText width-50 md-width-75 xs-width-100 font-size16 xs-font-size14 border-top border-bottom padding-10px-tb">
                Web Developer / Frontend Developer
              </p>
              {/* <div className="social-links margin-30px-bottom xs-margin-20px-bottom">
              
                
              </div> */}
              <SocialLinks classname="social-links margin-30px-bottom xs-margin-20px-bottom" />
              <a className="btn white" href="#portfolio">
                View My Portfolio{" "}
                <i className="fa fa-arrow-right font-size15 margin-5px-left" />
              </a>
            </div>
          </div>
          <div className="col-md-5 col-sm-12 order-1 order-md-2 text-right xs-text-center xs-border-bottom xs-padding-nineteen-half-lr border-color-medium-gray">
            <img
              src={require("../../../static/img/portfolio-pic-01.png")}
              alt="img/portfolio-pic-01.png"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
